export const prepareFilterForRequest = (filter, f) => {
  const { startDate, endDate, category, status } = filter;
  const today = f.getDateTime();

  return {
    category,
    status,
    date_range: {
      from: f
        .getDateTime({ date: startDate, fromUTC: true })
        .minus({ minutes: today.offset })
        .toSeconds(),
      to: f
        .getDateTime({ date: endDate, fromUTC: true })
        .minus({ minutes: today.offset })
        .toSeconds()
    }
  };
};
